var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseSecure',{attrs:{"admin":"","idp":[_vm.IDP.IDIR]}},[_c('v-container',[_c('transition',{attrs:{"name":"component-fade","mode":"out-in"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }